import React, { useEffect, useRef, useState } from "react";
import FunctionsTable from "./components/Functions/FunctionsTable";
import MUICard from "../../../UI/Card/MUICard";
import { Box, Typography, useMediaQuery } from "@mui/material";
import CertificatesTable from "./components/Certificates/CertificatesTable";
import FunctionModal from "./components/Functions/FunctionModal";
import { certificateData, functionData } from "../../../../data/data";
import CertificateDeleteModal from "./components/Certificates/CertificateDeleteModal";
import FunctionDeleteModal from "./components/Functions/FunctionDeleteModal";

//reading actual data

import { functionsData, certificatesData } from "../../../../data/actual_data";
import Loading from "../../../UI/Loading/Loading";
import { useNavigate } from "react-router-dom";

const Deployments = () => {
  const [openFuncModal, setOpenFuncModal] = useState(false);

  const [openFuncDelModal, setOpenFuncDelModal] = useState(false);
  const [openCertModal, setOpenCertModal] = useState(false);

  const [funcModalData, setFuncModalData] = useState(null);
  const [refreshTable, setRefreshTable] = useState(false);

  const smallerThan900 = useMediaQuery("(min-width:900px");

  const [certData, setCertData] = useState([]);
  const [funcData, setFuncData] = useState([]);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const isMounted = useRef(false);

  const handleOpenFuncModal = () => setOpenFuncModal(true);
  const handleCloseFuncModal = () => {
    setOpenFuncModal(false);
    setFuncModalData(null);
  };

  const openCertModalHandler = () => setOpenCertModal(true);
  const closeCertModalHandler = () => setOpenCertModal(false);

  const closeFuncDelModalHandler = () => setOpenFuncDelModal(false);
  const openFuncDelModalHandler = () => setOpenFuncDelModal(true);

  /*   useEffect(() => {
    if (funcModalData && funcModalData.functionId) {
      handleOpenFuncModal();
    }
  }, [funcModalData]); */

  const fetchFunctionsData = async () => {
    let func_endpoint = "https://rawdat.ai/login/portal/functions";
    try {
      const response = await fetch(func_endpoint, {
        credentials: "include",
      });

      /*
      if (!response?.ok || response.status === 401) {
        setLoading(false);
        navigate("/login");
        return;
      }
      */
      const data = await response.json();

      setFuncData(data);
    } catch (error) {
      console.error("Not able to fetch from function endpoint", error);
    }
  };

  const fetchCertificateData = async () => {
    let cert_endpoint = "https://rawdat.ai/login/portal/certificates";
    try {
      const response = await fetch(cert_endpoint, {
        credentials: "include",
      });

     
      /*
      if (!response?.ok || response.status === 401) {
        setLoading(false);
        navigate("/login");
        return;
      }
      */

      const data = await response.json();

      //certification data is actually an object

      if (data && Object.keys(data).length > 0) {
        const certDataKeys = Object.keys(data);

        const certData_Filter = certDataKeys.map((item) => {
          let name = item;

          let cert_key = data[item].key;

          let org = data[item].chain[0].issuer.organization;
          let validity = `${data[item].chain[0].validity.since} - ${data[item].chain[0].validity.until} `;

          return { name, key: cert_key, issuer: org, validity };
        });
        setCertData(certData_Filter);
      }
    } catch (error) {
      console.error("Not able to fetch from certificate endpoint", error);
    }
  };

  const fetchData = async () => {
    //setLoading(true);
    try {
      await Promise.all([fetchFunctionsData(), fetchCertificateData()]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error in fetching data in promise all", error);
    }
  };

  useEffect(() => {
    //function data

    if (isMounted.current) return;
    isMounted.current = true;

    fetchData();
  }, []);

  useEffect(() => {
    if (refreshTable) {
      fetchData();
      setRefreshTable(false);
    }
  }, [refreshTable]);

  const getFunctionData = (id, str) => {
    const filter = funcData.filter((item) => item.id === id);

    setFuncModalData((prev) => filter[0]);

    if (str === "del") {
      openFuncDelModalHandler((prev) => true);
    } else {
      setOpenFuncModal((prev) => true);
    }
  };

  const refreshHandler = () => {
    setRefreshTable(true);
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={6}
      width={smallerThan900 ? "1064px" : "90vw"}
      height={"100vh"}
    >
      <Loading open={loading} />
      <Box display={"flex"} flexDirection={"column"} gap={3}>
        <Typography variant="title">Functions</Typography>
        <MUICard>
          <FunctionsTable
            functionData={funcData}
            getData={getFunctionData}
            handleOpenFuncModal={handleOpenFuncModal}
          />
        </MUICard>
        {openFuncModal && (
          <FunctionModal
            open={openFuncModal}
            funcData={funcModalData}
            onClose={handleCloseFuncModal}
            refresh={refreshHandler}
          />
        )}

        {openFuncDelModal && (
          <FunctionDeleteModal
            funcData={funcModalData}
            open={openFuncDelModal}
            onClose={closeFuncDelModalHandler}
            refresh={refreshHandler}
          />
        )}
      </Box>

      <Box display={"flex"} flexDirection={"column"} gap={3}>
        <Typography variant="title">Certificates</Typography>
        <MUICard>
          <CertificatesTable data={certData} openClick={openCertModalHandler} />
          <CertificateDeleteModal
            open={openCertModal}
            onClose={closeCertModalHandler}
          />
        </MUICard>
      </Box>
    </Box>
  );
};

export default Deployments;
